export default __webpack_public_path__ + "static/media/e2d665cd60c254cd02096681e976aa701580397582022.f1603634.webp";